import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export const CommunityInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (request.url.includes(environment.api.community.url)) {
        const clone = request.clone({
            setHeaders: {
                HLIAMKey: environment.api.community.apiKey,
            },
            withCredentials: true,
        });
        console.debug('[Interceptors][CommunityInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(request);
    }
};
